import { Box, Typography } from "@mui/material";
import { useTranslation } from "../../translation/translate";

export default function SubHeaderTwo({ title = "" }) {
  const { getTranslation } = useTranslation();

  if (title === "") {
    title = getTranslation("WelcomeCDAMessage");
  }

  return (
    <Box
      className="WelcomeMessage"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h5" fontWeight="bold">
        {title}
      </Typography>
    </Box>
  );
}
